import { ROLE_NAME } from '@shootsta/common-domain-data';

export default function isShootstaAdminRoleName(roleName, status) {
  const { SHOOTSTA_TECH_SUPPORT } = ROLE_NAME;

  return [SHOOTSTA_TECH_SUPPORT].includes(roleName) && status === 'ACCEPTED';
}